export class VOIPDATA {

    ID: number;
    VQuad_Timestamp: Date;
    Start_Timestamp: Date;

    Call_Timestamp: Date;
    VQuad_Location: string;
    VQuad_PhoneID: string;

    GPS_Position: string;
    GPS_Lat: number;
    GPS_Long: number;
    Start_GPS_Position: string;
    Start_GPS_Lat: number;
    Start_GPS_Long: number;

    Net_Speed_Test: string;
    Battery_Level: number;
    RSSI: number;
    Network_Type: string;
    TN_Number: string;
 
    Target_Server: string;
    TestStatus: string;

    Up_Avg_Jitter: number;
    Up_Max_Jitter: number;
    Up_Packets_Out_of_Order: number;
    Up_Packet_Loss: number;
    Up_Packet_Discard: number;
    Dwn_Avg_Jitter: number;
    Dwn_Max_Jitter: number;
    Dwn_Packets_Out_of_Order: number;
    Dwn_Packet_Loss: number;
    Dwn_Packet_Discard: number;
    SIP_Register: number;
    SIP_Invite: number;
    SIP_Bye: number;
 
    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;
  
    constructor() {
          this.ID  = 0;
          this.VQuad_Timestamp  = new Date();
          this.Start_Timestamp  = new Date();
 
          this.Call_Timestamp  = new Date();
          this.VQuad_Location  = "";
          this.VQuad_PhoneID  = "";
 
          this.GPS_Position  = "";
          this.GPS_Lat  = 0;
          this.GPS_Long  = 0;
          this.Start_GPS_Position  = "";
          this.Start_GPS_Lat  = 0;
          this.Start_GPS_Long  = 0;
 
          this.Net_Speed_Test  = "";
          this.Battery_Level = 0;
          this.RSSI = 0;
          this.Network_Type  = "";
          this.TN_Number  = "";

          this.Target_Server  = "";
          this.TestStatus  = "";
 
          this.Up_Avg_Jitter  = 0;
          this.Up_Max_Jitter  = 0;
          this.Up_Packets_Out_of_Order  = 0;
          this.Up_Packet_Loss  = 0;
          this.Up_Packet_Discard  = 0;
          this.Dwn_Avg_Jitter  = 0;
          this.Dwn_Max_Jitter  = 0;
          this.Dwn_Packets_Out_of_Order  = 0;
          this.Dwn_Packet_Loss  = 0;
          this.Dwn_Packet_Discard  = 0;
          this.SIP_Register  = 0;
          this.SIP_Invite  = 0;
          this.SIP_Bye  = 0;
  
          this.CallType_Orig  = "";
          this.CallType_Term  = "";
          this.VQuad_CallID  = "";
  
    }
}
